<template>
  <v-card>
    <v-card-title class="title">
      <span>{{ title }}</span>
      <v-tooltip bottom>
        <v-icon slot="activator">help_outline</v-icon>
        <span>{{ hint }}</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text class="chart-container">
      <v-fade-transition>
        <v-progress-circular v-if="loading" indeterminate size="60" width="5"/>
        <div v-else-if="!data" class="no-data-msg">{{ $t('statistiche.label.no_data') }}</div>
        <div v-else>
          <slot :data="data"/>
        </div>
      </v-fade-transition>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: 'ChartCard',
    props: {
        title: String,
        hint: String,
        loading: Boolean,
        data: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style scoped lang="scss">
  .v-card__title {
    .v-icon {
      color: rgba(0, 0, 0, 0.87);;
      margin-left: 32px;
    }
  }

  .chart-container {
    text-align: center;
    min-height: 232px;

    & .g-chart--geochart {
      width: 70%;
      margin: -16px auto auto;
    }

  }

  .v-progress-circular {
    position: absolute;
    top: calc(50% - 30px);
    left: calc(50% - 30px);
  }

  .no-data-msg {
    font-size: 18px;
    font-style: italic;
    font-weight: 400;
    margin-top: 30px;
    margin-bottom: 100px;
  }
</style>
